import React from 'react';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import { render } from 'react-dom';
import { App } from './App';
import theme from './theme';
import { HelmetProvider } from 'react-helmet-async';
render(<HelmetProvider data-id="element-332">
    <ColorModeScript initialColorMode={theme.config.initialColorMode} data-id="element-333" />
    <ChakraProvider theme={theme} data-id="element-334">
      <App data-id="element-335" />
    </ChakraProvider>
  </HelmetProvider>, document.getElementById('root'));